const STEPS = [
	{
		title: "O canteiro posta",
		text: "Quem está na obra publica o relato com fotos e vídeos, marca a etapa e bate o ponto pelo celular. O clima do momento entra sozinho.",
	},
	{
		title: "O engenheiro acompanha",
		text: "Medições atualizam o avanço de cada etapa. O cronograma mostra onde o realizado descolou do previsto, e o painel aponta as obras atrasadas.",
	},
	{
		title: "O Relatório de Obra sai pronto",
		text: "No fim do dia, o Relatório de Obra reúne atividades, fotos, clima e equipe. Um clique finaliza e gera o PDF com a marca da construtora.",
	},
];

export function HowItWorks() {
	return (
		<section data-slot="band" id="como-funciona">
			<div data-slot="wrap">
				<div data-slot="section-intro">
					<p data-slot="eyebrow">Como funciona</p>
					<h2 data-slot="section-title">O registro do dia já é o relatório.</h2>
					<p data-slot="section-lede">
						Nada de caderno no canteiro, planilha no escritório e alguém
						juntando tudo às sete da noite. Cada informação entra uma vez, por
						quem estava lá.
					</p>
				</div>
				<ol data-slot="steps">
					{STEPS.map((step, index) => (
						<li key={step.title} data-slot="step">
							<span data-slot="step-number" aria-hidden="true">
								{index + 1}
							</span>
							<h3 data-slot="step-title">{step.title}</h3>
							<p data-slot="step-text">{step.text}</p>
						</li>
					))}
				</ol>
			</div>
		</section>
	);
}
